import { View } from 'react-native'

import { BaseModalConfig } from '../'
import { translate } from '../../../../../i18n'
import { ConfirmOption } from '../../../BottomModalContent/Content'
import { styles } from './GameDelete.style'
import { DS } from '../../../../../design-system'
import { ProgressBar } from '../../../ProgressBar'

export interface GameDeleteProps extends BaseModalConfig {
  confirm: ConfirmOption
}

export const GameDelete = ({ confirm }: GameDeleteProps) => {
  const maxTime = 5 * 1000

  return (
    <View style={styles.modalContainer}>
      <DS.Frame style={[styles.container, { alignItems: 'center', gap: DS.spacing[8] }]}>
        <DS.Icon name="Minus--enclosed" width={40} height={40} />
        <DS.Text variant="Heading 3/Medium">{translate('gameScreen.gameDeletedMessage')}</DS.Text>
        <DS.Text variant="Body Small/Regular">{translate('gameScreen.gameDeletedMessageReturn')}</DS.Text>
        <DS.Frame style={{ height: 8, width: '100%', marginVertical: DS.spacing[8] }}>
          <ProgressBar
            duration={maxTime}
            maxDuration={maxTime}
            color={'Brand/Orange'}
            backgroundColor="Global/Black"
            backgroundOpacity={0.5}
            onComplete={confirm.onPress}
          />
        </DS.Frame>
        <DS.Button variant="Large/Primary" type="On Light" onPress={confirm.onPress}>
          {translate('gameScreen.quickGameOver.goToPlay')}
        </DS.Button>
      </DS.Frame>
    </View>
  )
}
